import React from 'react';

import { PolicyInfo as SharedPolicyInfo } from '#src/app/shared/components/payments';

import { usePromoteFormData } from '../../formContext';

export const PolicyInfo: React.FC<EmptyProps> = () => {
	const {
		featureConfigs: { useDonationLanguage },
	} = usePromoteFormData();

	return <SharedPolicyInfo useDonationLanguage={useDonationLanguage} />;
};
